
		export default class PageState{
			//模板生成============================================================================
			self:any = null;
			title: string = "";
			//============================================================================
			serviceWechat: any = ""
		}